import React from 'react';

const ContactMessage = (props) => {
  return (
    <p className="contact-message">{props.cName}</p>
  );
}

export default ContactMessage;